import { styled } from '@mui/material/styles';
import {
    Box, IconButton,
} from '@mui/material';

import { CenteredFlex } from '../../foundation/Flex';
import Button from '../../foundation/Button';

export const JobItemStyled = styled('div')`
    border-radius: 10px;
    box-shadow: 0 10px 36px 0 #eeeff1cc;
    border: solid 1px #d1dce4;
    background-color: #ffffff;
    padding: 1rem;
    .MuiTypography-body1 {
        unicode-bidi: embed;
        white-space: pre-line;
        overflow-wrap: break-word;
    }
`;

// note that direction needs to be opposite because the theme direction is set to rtl
export const JobDetailsStyled = styled('div') <{ dirAlign: 'ltr' | 'rtl' }>`
    direction: ${props => (props.dirAlign === 'ltr' ? 'rtl' : 'ltr')};
    margin-top: 10px;
    p {
        margin: 0;
        white-space: pre-line;
        overflow-wrap: break-word;
    }
`;

export const IconButtonStyled = styled(IconButton)`
    width: 60px;
    height: 60px;
    border-radius: 8px;
    background-color: #f9f9fb;
    cursor: pointer;
`;

export const LinkedInButtonStyled = styled(Button)`
    background-color: #0077B5;
    &:hover {
        background-color: #005582;
    }
    svg {
        filter: brightness(0) invert(1);
    }
`;

export const SimilarityGaugeStyled = styled(CenteredFlex)`
    margin-inline-end: auto;
    margin-inline-start: auto;
    padding-inline-start: 5px;
    border-radius: 8px;
    width: 100%;
    margin-bottom: 10px;;
    background-color: #f9f9fb;
`;

export const RedIconButtonStyled = styled(IconButton)`
    width: 65px;
    height: 60px;
    border-radius: 8px;
    background-color: #ffecec;
    cursor: pointer;
    svg {
        color: #ff4b4b;
    }
`;

export const DateStyled = styled(Box)`
    padding: 10px;
    border-radius: 8px;
    background-color: #f9f9fb;
    color: ${props => props.theme.palette.secondary.main};
`;

export const PhoneButtonStyled = styled(Box)`
    display: flex;
    .MuiButtonBase-root {
        background-color:#0291ef;
    }
`;
export const ExtraDataStyle = styled(Box)`
    color: #8799a5;
    padding: 5px 0;
`;

export const DesktopOnly = styled(Box)(({ theme }) => ({
    display: 'block',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

export const JobTitleRow = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1.5),
    marginBottom: 5,
}));

export const CompanyLogoContainer = styled(Box)({
    display: 'flex',
    flexShrink: 0,
    '& a': {
        display: 'flex',
    },
    '& img': {
        display: 'block',
    },
});
